export default __webpack_public_path__ + "static/img_4-ac456a9732978a5d9a64f28f6223e793.png";